const React = require("react")

const ContractsOrders = ({ ...props }) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.99875 21.0036H4.99708C3.89205 21.0036 2.99625 20.1078 2.99625 19.0028V4.99693C2.99625 3.8919 3.89205 2.99609 4.99708 2.99609H17.0021C18.1071 2.99609 19.0029 3.8919 19.0029 4.99693V7.99818"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21.0041L14.6251 20.68C14.8098 20.6571 14.9816 20.5733 15.1133 20.4419L21.4739 14.0812C22.1785 13.3797 22.1811 12.24 21.4799 11.5351L21.4739 11.5301V11.5301C20.7724 10.8256 19.6327 10.8229 18.9279 11.5241V11.5301L12.6253 17.8328C12.497 17.9601 12.4141 18.126 12.3892 18.305L12 21.0041Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99834 17.0013V17.0013C7.16956 17.0013 6.49771 16.3294 6.49771 15.5006V15.5006C6.49771 14.6719 7.16956 14 7.99834 14V14C8.82711 14 9.49896 14.6719 9.49896 15.5006V15.5006C9.49896 16.3294 8.82711 17.0013 7.99834 17.0013Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49771 7.00021H14.501"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49771 10.5002H10.4994"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

module.exports = {
  ContractsOrders
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/menu/icons/contractsOrders.js